import FAQ from 'components/faq/FAQ';
import LandingHero from 'components/landingHero/LandingHero';
import faqs from 'modules/faqs';
import { userBasicInfoPublicPages } from 'modules/graphqlQueries';
import { useState } from 'react';
import { InputStyled } from 'styles/support.styles';

import Layout from '../components/layout/Layout';
import { useLoadData } from '../modules/useLoadData';
import { UserType } from '../types/UserTypes';

const getQuery = (userId) => `{
  user(_id: "${userId}") {
    ${userBasicInfoPublicPages}
  }
}`;

const Support = (): JSX.Element => {
  const [searchTerm, setSearchTerm] = useState<string>('');

  const {
    isLoading,
    response: {
      data: { user },
    },
  } = useLoadData(getQuery);

  const filteredFaqs = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout user={user as UserType} isLoading={isLoading}>
      <LandingHero image="/support.webp" title="Need help?" size="md">
        <InputStyled
          name="search"
          type="text"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
          placeholder="Search here..."
        />
      </LandingHero>
      <FAQ faqs={filteredFaqs} showMore={false} />
    </Layout>
  );
};

export default Support;
